import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import {
  PULSELEADS_AUTO_LEAD_REASSIGNMENT_PATH,
  PULSELEADS_AUTO_LEAD_REASSIGNMENT_STATUS_RULE_PATH,
  PULSELEADS_AUTO_LEAD_REASSIGNMENT_TERMINATED_AGENT_RULE_PATH
} from './constants';
import { PULSELEADS_BASE_PATH } from '../../constants';
import StatusRuleListingPage from './RulesPage/List/RulesListingPage';
import StatusRuleDetailPage from './RulesPage/Detail/RulesDetailPage';
import StatusRuleLeadListingPage from './RulesPage/LeadList/RulesLeadListingPage';
import { RulesType } from '../../types/auto-lead-reassignment-types';

const autoLeadReassignmentPath = `${PULSELEADS_BASE_PATH}${PULSELEADS_AUTO_LEAD_REASSIGNMENT_PATH}`;
export const autoLeadReassignmentStatusRulePath = `${autoLeadReassignmentPath}${PULSELEADS_AUTO_LEAD_REASSIGNMENT_STATUS_RULE_PATH}`;
export const autoLeadReassignmentTerminatedAgentRulePath = `${autoLeadReassignmentPath}${PULSELEADS_AUTO_LEAD_REASSIGNMENT_TERMINATED_AGENT_RULE_PATH}`;

const AutoLeadReassignmentRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <PruRoute exact path={`${autoLeadReassignmentStatusRulePath}`}
        render={(props) => (
          <StatusRuleListingPage
            {...props}
            ruleType={RulesType.statusRule}
          />
        )} />
      <PruRoute exact path={`${autoLeadReassignmentStatusRulePath}/create`} render={(props) => (
        <StatusRuleDetailPage
          {...props}
          ruleType={RulesType.statusRule}
        />
      )} />
      <PruRoute exact path={`${autoLeadReassignmentStatusRulePath}/view/:id`} render={(props) => (
        <StatusRuleDetailPage
          {...props}
          ruleType={RulesType.statusRule}
        />
      )} />
      <PruRoute exact path={`${autoLeadReassignmentStatusRulePath}/:id/lead-list`} render={(props) => (
        <StatusRuleLeadListingPage
          {...props}
          ruleType={RulesType.statusRule}
        />
      )} />

      {/* Terminated Agent Rule Routes */}
      <PruRoute exact path={`${autoLeadReassignmentTerminatedAgentRulePath}`}
        render={(props) => (
          <StatusRuleListingPage
            {...props}
            ruleType={RulesType.terminatedAgentRule}
          />
        )} />
      <PruRoute exact path={`${autoLeadReassignmentTerminatedAgentRulePath}/create`} render={(props) => (
        <StatusRuleDetailPage
          {...props}
          ruleType={RulesType.terminatedAgentRule}
        />
      )} />
      <PruRoute exact path={`${autoLeadReassignmentTerminatedAgentRulePath}/view/:id`} render={(props) => (
        <StatusRuleDetailPage
          {...props}
          ruleType={RulesType.terminatedAgentRule}
        />
      )} />
      <PruRoute exact path={`${autoLeadReassignmentTerminatedAgentRulePath}/:id/lead-list`} render={(props) => (
        <StatusRuleLeadListingPage
          {...props}
          ruleType={RulesType.terminatedAgentRule}
        />
      )} />

      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default AutoLeadReassignmentRoutes;
